import { DomSanitizer } from '@angular/platform-browser';
import { Component, Input, OnInit, TemplateRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { PageChangedEvent } from "ngx-bootstrap/pagination";
import { EssentialService } from "../../services/essential.service";

@Component({
  selector: "lib-blog-archive",
  templateUrl: "./blog-archive.component.html",
  styleUrls: ["./blog-archive.component.css"],
})
export class BlogArchiveComponent implements OnInit {
  @Input() public settings: any;
  @Input() public data: any;

  public category: any;
  public totalItems = 0;
  public showItems = 0;
  public disblayedPosts: any[] = [];
  public rotate = true;
  public maxSize = 5;
  @Input() public selectedBlock: any = {};
  public posts: any[] = [];
  public PostImages: any;
  public boxShadow: any = "";
  public borderAll: any = "";
  public borderTop: any;
  public borderLeft: any;
  public borderRight: any;
  public borderBottom: any;
  public cardBoxShadow: string;
  public site: any;
  public filterItems: any[] = [];
  public carouselOptions: any;
  public selectedfilter: any;
  public linkOptions: any = {};
  public slugSettings: any;
  public APIData: any[];
  public modalRef: BsModalRef;
  public prefix: any;
  public filteredPosts: any[] = [];

  constructor(
    private modalService: BsModalService,
    private essentialsService: EssentialService,
    private routing: Router,
     private sinitizer: DomSanitizer) { }

  public ngOnInit() {
    if (
      this.settings &&
      this.settings.relatedPostsSettings &&
      this.settings.relatedPostsSettings.component &&
      this.settings.relatedPostsSettings.component.setting
    ) {
      this.settings = this.settings.relatedPostsSettings.component.setting;
    }
    this.settings.colList = this.settings.colList || [];
    this.settings.selectedCategories = this.settings.selectedCategories || [];
    this.carouselOptions = {
      slideBy: this.settings.itemsPerPage,
      mouseDrag: true,
      touchDrag: true,
      autoplay: false,
      loop: true,
      navText: [
        "<div class='prev-slide'><i class='fas fa-angle-left fa-2x'></i></div>",
        "<div class='next-slide'><i class='fas fa-angle-right fa-2x'></i></div>",
      ],
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 1,
        },
        1000: {
          items: +this.settings.itemsPerPage,
        },
        1500: {
          items: +this.settings.itemsPerPage,
        },
      },
    };

    this.site = this.data.moduleService.site;
    this.prefix = "/" + this.data.moduleService.site.HostName;
    if (this.settings.selectedCategories.length > 0) {
      this.getPosts(this.settings.selectedCategories);
    }

    if (this.settings.boxShadowOutline) {
      this.boxShadow = "inset";
    } else {
      this.boxShadow = "";
    }
    if (this.settings.cardBoxShadow) {
      this.cardBoxShadow = "inset";
    } else {
      this.cardBoxShadow = "";
    }
    if (!this.settings.borderAll) {
      this.borderAll = "none";
    } else {
      this.borderAll =
        this.settings.bordersize +
        "px " +
        this.settings.borderType +
        " " +
        this.settings.bordercolor;
    }

    if (this.borderAll === "none") {
      this.borderTop =
        this.settings.borderTop +
        "px " +
        this.settings.borderType +
        " " +
        this.settings.bordercolor;
      this.borderLeft =
        this.settings.borderLeft +
        "px " +
        this.settings.borderType +
        " " +
        this.settings.bordercolor;
      this.borderRight =
        this.settings.borderRight +
        "px " +
        this.settings.borderType +
        " " +
        this.settings.bordercolor;
      this.borderBottom =
        this.settings.borderBottom +
        "px " +
        this.settings.borderType +
        " " +
        this.settings.bordercolor;
    }
    const css =
      `.blog-` +
      this.settings.id +
      `
    {
      box-shadow:` +
      this.boxShadow +
      " " +
      this.settings.hoffset +
      "px " +
      this.settings.voffset +
      "px " +
      this.settings.blur +
      "px " +
      this.settings.spread +
      "px " +
      this.settings.boxcolor +
      `!important;
    }
    .blog-` +
      this.settings.id +
      ` .card  {
      border: ` +
      this.borderAll +
      `;
    border-top: ` +
      this.borderTop +
      `;
    border-left:` +
      this.borderLeft +
      `;
    border-right:` +
      this.borderRight +
      `;
    border-bottom:` +
      this.borderBottom +
      `;
    border-radius:` +
      this.settings.borderRadius +
      `px;
      box-shadow:` +
      this.cardBoxShadow +
      " " +
      this.settings.hoffsetCard +
      "px " +
      this.settings.voffsetCard +
      "px " +
      this.settings.blurCard +
      "px " +
      this.settings.spreadCard +
      "px " +
      this.settings.boxcolorCard +
      `!important;
    }`;
    const head = document.getElementsByTagName("head")[0];
    const style = document.createElement("style");
    style.appendChild(document.createTextNode(css));
    head.appendChild(style);
  }
  public getPosts(ids) {
    var data = {
      categoriesIds: ids || [],
      searchValue: "",
      pageSize: 1000,
      pageNo: 0,
      postsSort:{
        SortField : this.settings.orderBy,
        SortType : this.settings.orderType ? this.settings.orderType === "-" ? 2:1 : 2
      }
    }


    this.essentialsService.getPosts(data).subscribe((res: any) => {
      this.posts = res.list;
      this.APIData = [];

      if ((this.APIData = this.posts && this.posts.length ? this.posts : [])) {
        this.APIData.sort(
          this.compareValues(this.settings.orderBy, this.settings.orderType)
        );
        this.totalItems = this.posts.length;
        this.disblayedPosts =
          this.settings.loadingPost !== "none"
            ? this.posts.slice(0, this.settings.itemsPerPage)
            : this.posts;
        this.showItems = this.disblayedPosts.length;
      }
      this.posts.forEach((element) => {
        if (element.settings) {
          element.settings = JSON.parse(element.settings);
          if (element.settings.isExternal && element.settings.link) {
            this.slugSettings = true;
          }
        }
      });

      if (this.settings.filter !== "none") {
        this.posts.forEach((element) => {
          const blogDate = new Date(element.statusDate);
          const filterItem =
            this.settings.filter === "months"
              ? this.getMonthName(blogDate)
              : blogDate.getFullYear();
          if (!this.checkIfExist(this.filterItems, filterItem)) {
            this.filterItems.push({
              label: filterItem,
              value:
                this.settings.filter === "months"
                  ? blogDate.getMonth()
                  : blogDate.getFullYear(),
            });
          }
        });

        if (this.settings.filterOrder === "asc") {
          this.filterItems.sort((a, b) => {
            return a.value - b.value;
          });
        } else {
          this.filterItems.sort((a, b) => {
            return b.value - a.value;
          });
        }
      }

      if (this.settings.template === "slider") {
        this.totalItems = this.posts.length;
        this.disblayedPosts = this.posts;
        this.showItems = this.disblayedPosts.length;
      } else {
        this.totalItems = this.posts.length;
        this.disblayedPosts =
          this.settings.loadingPost !== "none"
            ? this.posts.slice(0, this.settings.itemsPerPage)
            : this.posts;
        this.showItems = this.disblayedPosts.length;
      }
      if (this.settings.filter !== "none") {
        this.filterPosts(this.filterItems[0]);
      }

      if (this.settings.shuffle) {
        shuffle(this.disblayedPosts);
      }

    });
  }
  public openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  public compareValues(key: string | number, order = "") {
    return function innerSort(a, b) {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        return 0;
      }

      const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
      const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return order === "-" ? comparison * -1 : comparison;
    };
  }

  public checkIfExist(filterItems: any[], filterItem: string | number) {
    return filterItems.find((i) => i.label === filterItem) ? true : false;
  }
  public convertJson(obj) {
    obj = JSON.parse(obj);
    if (obj.isExternal && obj.link) {
      return obj.link;
    }
  }
  public GoTopage(post) {
    if (post.templateId != 1 && (post.slug && post.slug != " ")) {
      this.routing.navigate([this.prefix + "/" + post.slug]);
    }
  }
  public filterPosts(filter: { value: number }) {
    this.selectedfilter = filter;
    this.disblayedPosts = [];
    if (this.settings.filter === "months") {
      this.filteredPosts = this.posts.filter(
        (e) => new Date(e.statusDate).getMonth() === filter.value
      );
    } else {
      this.filteredPosts = this.posts.filter(
        (e) => new Date(e.statusDate).getFullYear() === filter.value
      );
    }
    this.totalItems = this.filteredPosts.length;

    this.pageChanged({});
  }
  public pageChanged(event: any): void {
    event.page = event.page || 1;
    event.itemsPerPage = event.itemsPerPage || this.settings.itemsPerPage || 3;

    const startItem = (event.page - 1) * event.itemsPerPage;
    const endItem = event.page * event.itemsPerPage;

    if (this.settings.filter !== "none") {
      this.disblayedPosts = this.filteredPosts.slice(startItem, endItem);
    } else this.disblayedPosts = this.posts.slice(startItem, endItem);
  }
  public increaseShow() {
    this.showItems += this.settings.itemsPerPage;
    this.disblayedPosts = this.posts.slice(0, this.showItems);
  }
  public decreaseShow() {
    if (this.showItems > this.settings.itemsPerPage) {
      this.showItems -= this.settings.itemsPerPage;
      this.disblayedPosts = this.posts.slice(0, this.showItems);
    }
  }
  public getMonthName(dt): string {
    const mlist = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return mlist[dt.getMonth()];
  }
  public getThumbnailUrl(item) {
    return this.sinitizer.bypassSecurityTrustUrl(item.thumbnailURL);
  }
  public getFirstImgUrl(item) {
    return this.sinitizer.bypassSecurityTrustUrl(item.thumbnailURL);
  }


  // public getImagesUrl(item) {
  //   return this.sinitizer.bypassSecurityTrustUrl(item.thumbnailURL);
  // }
}

export function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}